module.exports = __webpack_public_path__ + "media/images/dashboard-implementation-88cb431c.png";